import { ElementContext, ElementContextType } from "@/lib/context";
import { useContext } from "react";

export function useElement<T = any, Selected = unknown>(): ElementContextType<
  T,
  Selected
> {
  const context = useContext(ElementContext);

  if (!context) {
    throw new Error("useElement must be used within a ElementProvider");
  }

  return context as ElementContextType<T, Selected>;
}
